import { Box, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';


const SousMenuItem = ({ label, path, setDrawerOpen }) => {
  const location = useLocation(); // ou currentPath si tu l'as déjà
  const navigate = useNavigate();
  const isActive = location.pathname === path || location.pathname.startsWith(path);

  return (
    <Box
      onClick={() => {navigate(path); setDrawerOpen(false)}}
      sx={{
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        color: isActive ? 'var(--color-blue-primary)' : 'var(--color-text)',
      }}
    >
      <FiberManualRecordIcon
        sx={{
          fontSize: 8,
          color: isActive ? 'var(--color-blue-primary)' : 'var(--color-dark-grey)',
          mr: 1,
        }}
      />
      <Typography>{label}</Typography>
    </Box>
  );
};

export default SousMenuItem;